import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

import theme from '../../theme';

const ModalBody = (props) => {
  const {
    editMode,
    isLoading,
    inputErrorMsg,
    setInputErrorMsg,
    modalContent,
    modalData,
    setModalData,
    handleModalSubmit,
    handleClose,
    mainColor
  } = props;

  switch (modalContent.render) {
    case 'default':
      return (
        <Box>
          <Typography>{modalContent.content}</Typography>
          {
            modalContent.field &&
            <Typography
              variant='h5'
              sx={{
                mt: 3,
              }}>
              {modalData[modalContent.field]}
            </Typography>
          }
        </Box>
      )
    case 'locale':
      return (
        <Box mb={2}>
          <Typography
            sx={{
              color: modalContent.color?.text ? modalContent.color.text : theme.palette.text.primary,
              mt: 2,
            }}
          >
            <FormattedMessage id={modalContent.content} />
          </Typography>
          {
            modalContent.field &&
            <Typography
              sx={{
                color: modalContent.color?.field ? modalContent.color?.field : mainColor
              }}>
              {modalData[modalContent.field]}
            </Typography>
          }
        </Box>
      )
    case 'processing':
      return (
        <Box p={2}>
          <Box mb={4}>
            <Typography
              sx={{
                color: modalContent.color?.text ? modalContent.color.text : theme.palette.text.primary,
                mt: 2,
              }}
            >
              <FormattedMessage id={modalContent.content} />
            </Typography>
          </Box>
          <CircularProgress color="inherit" />
        </Box>
      )
    // case 'chooseSaveReport':
    //   return <ChooseSaveReport {...props} />
    default:
      break;
  }
}


export default ModalBody;